import { ReactNode } from "react";
import { useAccessibility } from "../../Store/contexts/AccessibilityContext";
import Footer from "../Footer";
import HeaderLogin from "../HeaderLogin";
import BoletoWelcome from "./BoletoWelcome";
import './styles.css';

interface Props {
    children: ReactNode;
}

export default function AuthLayoutSimple({ children }: Readonly<Props>) {

    const { contrastMode } = useAccessibility();

    return (
        <div className={contrastMode ? 'container-boleto' : 'container-boleto img-background-boleto'}>
            <div className='container-boleto-painel'>
                <BoletoWelcome />
                <div className='width-100 boleto-container-end'>{children}</div>
            </div>
            <Footer />
        </div>

    )
}
